import React from 'react';
import { Table, Space, Tooltip, Button, Typography, Upload } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import moment from 'moment';

export const DeclareCustomsTable = ({ dataSource, handleEdit, handleDelete, handleAdd, handleImport, importing, isEsidExpFinalized, loading }) => {
  const { t } = useTranslation("common");

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      width: '10%',
      render: (_, __, index) => index + 1,
    },
    {
      title: t('admin.acceptance.custRefNumHolder'),
      dataIndex: 'codCusRefNum',
      key: 'codCusRefNum',
      width: '40%',
    },
    {
      title: t('admin.acceptance.custIssDateHolder'),
      dataIndex: 'datCusIss',
      key: 'datCusIss',
      width: '30%',
      render: (value) => (value ? moment(value).format('DD/MM/YYYY') : ''),
    },
    {
      dataIndex: 'action',
      width: '20%',
      fixed: 'right',
      hidden: isEsidExpFinalized,
      render: (_, record) => (
        <Space>
          <Tooltip title={t("dangerousGood.tableInfo.btnEdit")}>
            <Button type="text" onClick={() => handleEdit(record)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title={t("dangerousGood.tableInfo.btnDelete")}>
            <Button type="text" onClick={() => handleDelete(record)} danger icon={<DeleteOutlined />} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <Table
      bordered
      rowKey="id"
      dataSource={dataSource}
      loading={loading}
      scroll={{ x: 300 }}
      columns={columns.filter((col) => !col.hidden)}
      pagination={false}
      title={() => (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography.Text strong>{t('admin.acceptance.customsDeclList')}</Typography.Text>
          {!isEsidExpFinalized && (
            <Space>
              <Upload
                beforeUpload={(file) => {
                  handleImport(file);
                  return false;
                }}
                showUploadList={false}
                accept=".xls,.xlsx"
              >
                <Button loading={importing} icon={<UploadOutlined />}>
                  {t('importCsv')}
                </Button>
              </Upload>
              <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
                {t('addBtn')}
              </Button>
            </Space>
          )}
        </div>
      )}
      style={{ marginTop: 10, padding: '2px 5px' }}
    />
  );
};
